export const BUBBLE_SIZE = {
  lg: 120,
  md: 100,
  xs: 60,
};

export const DESVIATION = 30;

export const FIRST_LEVEL_INFO_ZOOM = {
  lg: 0.8,
  md: 1.2,
  xs: 1.6,
};


export const SECOND_LEVEL_INFO_ZOOM = {
  lg: 1.5,
  md: 2.3,
  xs: 2.8,
};

export const MARGIN_OFFSET = 20;

export const MARGIN_BUBBLE = 30;

export const MAX_TAGS = 2;

export const MAX_ORBIT_SATELLITES = 3;
export const MAX_INLINE_ELEMENTS = 1;

export const SATELLITES_SIZE = {
  lg: 40,
  md: 30,
  xs: 24,
};

export const INLINE_ELEMENTS_SIZE = {
  lg: 20,
  md: 14,
  xs: 8,
};

export const ZOOM_WHEEL = 5;



// WEBPACK FOOTER //
// ./src/components/ThemeTablesBubbles/components/constants.js